<template>
  <div v-title :data-title="this.$t('title.all')+this.$t('title.online')">
    <div class ="mobile-view">
      <router-link to="/mine/doc">
      <div class="mobile-view-poster">{{$t('fanyi.toPersonal')}}</div></router-link>
    </div>
    <div class="pc-view">
      <Navbar></Navbar>
      <div class="main">
        <div class="lang-container clearfix">
          <div class="lang">
            <div id="langSelect" class="lang-group lang-select item-select">
              <span class="select-text" @click="openLang">{{selectHtml}}</span>
              <ul id="languageSelect"
                v-if="langModel"
                :class="['select', 'clear', 'en-select',{'isEngCss':isChinese}]">
                <li v-for="(item,index) in list"
                  v-bind:class="[{'default':index==0},
                  {'docHidden':index==0}]"
                  :key="index"
                  v-if="item.isfile || !file['name']"
                  data-value="item.value">
                  <a v-bind:class="[{'selected':item.active}]"
                   @click="changeLang(item,index)"
                   href="javascript:;">{{item.title}}</a>
                </li>
              </ul>
              <input class="select-input"
                   id="language"
                   name="language"
                   type="hidden" value="zh-CHS2en">
            </div>
            <div class="lang-group">
              <div class="lang-translate-btn"
                 @click="translateButton">{{$t('fanyi.button')}}</div>
            </div>
          </div>
          <div :class="['textpanel-source',{'active':clickActive}]">
              <div class="textpanel-source-textarea" 
                   data-active='1'>
                <div  id="text-pre-html"
                      v-if="itemMove">
                  <div class="text-pre-html-box" data-active='1'>
                    <p v-for="(item,index) in bgHtml"
                       :key="index">{{item}},{{index}}</p>
                  </div>
                  <span class="translate-html hover-target-translate"
                        v-bind:style="{'top':hoverTargerHeight+'px'}">{{hoverTrans}}</span>
                </div>
                <textarea class="textinput"
                      data-active='1'
                      id="textarea"
                      v-model="content"
                      @keyup="onKeyup"
                      node-type="source-textarea"
                      :placeholder="$t('fanyi.placeholder')"></textarea>
              </div>
              <a class="text-delete"
                 @click="clearBox"
                 href="javascript:;"
                 v-if="delHtml"></a>
              <div id="docUploadBg"
                   v-if="upFileBox">
                    <span class="doc-type"></span>
                <div class="doc-infos">
                    <p class="doc-name">{{file.name}}</p>
                    <span class="doc-size-msg"
                          style="display: inline;">{{file.size}}</span>
                </div>
                <a class="doc-delete"
                    @click="clearFile" href="javascript:;"></a>
              </div>
              <div  id="docUpload"
                    v-if="!delHtml"
                    class="doc-upload">
                <form id="docUploadForm"
                      method="post" enctype="multipart/form-data">
                      <span>{{$t('fanyi.upbutton')}}</span>
                      <input  type="file"
                              id="docUploadFile"
                              accept=".docx,.pdf"
                              @click="isLogin($event)"
                              @change="changeFile($event)"
                              class="doc-upload-file">
                      <div class="file-tips" style="">
                          <div>{{$t('fanyi.upMessage')}}</div>
                      </div>
                </form>
              </div>
              <div  class="textpanel-tool tool-close"
                    node-type="source-clean-btn" 
                    style="display: block;"></div>
          </div>
          <div class="textpanel-target-textarea">
            <div id="target-textblock" class="textpanel-target-textblock">
              <div class="text-target" id="texttarget">
                <p data-caiyun-tragetId="'+i+'"
                   v-for="(item,index) in transHtml"
                   :class="[{ nodata: item =='' }]"
                   @mouseover="moveItem(index)"
                   @mouseleave="moveLeaveItem()"
                   :key="index">
                  <span class="target-translate">{{item}}</span></p>
              </div>
            </div>
            <button class="textpanel-tool tool-copy"
               v-if="transHtml.length>0"
               @mouseover="copyMove"
               @click="copy"
               :data-clipboard-text="copyContent"
               @mouseleave="copyLeave()"
               node-type="target-copy-btn"></button>
            <div class="textpanel-tool tool-copy-tips"
               v-if="copyFlag"
               node-type="tool-copy-tips">
              <span class="tool-copy-tips-text">{{copyhtml}}</span>
              <span class="tool-copy-tips-arrow"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="foot-container"></div>
      <AlertInfo></AlertInfo>
      <div class="alert-progress" v-if="progressFlag">
        <div class="progress">
        <!--<div class="close"></div>-->
          <p class="progress-file">{{file.name}}</p>
          <div class="progress-line-state">
            <div class="progress-item upfile">
              <el-progress  :stroke-width="20"
                          :show-text="false"
                          :percentage="progress"
                          color="#5cb85c"></el-progress>
            </div>
            <div class="progress-item trFile" v-if="isFanyi">
              <el-progress  :stroke-width="20"
                          :show-text="false"
                          :percentage="fprogress"
                          color="#5cb85c"></el-progress>
            </div>
            <div class="progress-item"
               id="progressNum">{{isProgress}}</div>
          </div>
          <p class="progress-html" id="progressHtml">{{isFileSatus}}</p>
        </div>
      </div>
      <LoginModel ref="loginModel"></LoginModel>
    </div>
  </div>
</template>
<style  scoped>
  @import '../css/fanyi.scss';
  @import "../css/progress-line.scss";
  .mobile-view{
    display: none;
    position: fixed;
    top:0;
    left:0;
    right: 0;
    bottom:0;
    z-index: 999;
  }
  .mobile-view-poster{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    color:#5ebb8d;
    border-bottom: 1px solid #5ebb8d;
    padding-bottom: 4px;
  }
  @media (max-width: 650px) {
    .pc-view{
      display: none;
    }
    .mobile-view{
      display: block;
    }
  }

</style>
<script>
  const MAXFILE = 20;
  import Navbar from '../components/Navbar';
  import AlertInfo from '../components/AlertInfo';
  import { getTranslator,USER_INFO } from '@/api/user';
  import {translate,changeLangeType,autoTextarea,postFile,getStatus} from '@/api/doc';
  import Clipboard from 'clipboard';
  import { Message, MessageBox } from 'element-ui'
  import LoginModel from '../components/LoginModel';
  import {getSignature} from '@/api/weixin';
  import{ whatLang }from'@/utils/index';
  import $ from 'jquery';

  let timer = null ;
  let statusInterval = null;
  export default{
    components:{Navbar,AlertInfo,LoginModel},
    data () {
      return {
        selectFlag: false,
        selectHtml:this.$t('fanyi._translate[0]'),
        transType:'auto',
        text:'',
        translation:'',
        fileButton:true,
        langModel:false,
        time:null,
        upFileBox:false,
        isProgress:'',
        progressFlag:false,
        isFileSatus:this.$t('fanyi.isFileArr[0]'),
        copyhtml:this.$t('fanyi.isCopyArr[0]'),
        oldText:'',
        isChinese: whatLang() !='zh',
        list: [
          {
            title: this.$t('fanyi._translate[0]'),
            value:'auto',
            active:true,
            isfile:false
        },{
            title:this.$t('fanyi._translate[1]'),
            value:'zh2en',
            active:false,
            isfile:true
          },
          {
            title:this.$t('fanyi._translate[2]'),
            value:'en2zh',
            active:false,
            isfile:true
          },
          {
            title:this.$t('fanyi._translate[3]'),
            value:'zh2ja',
            active:false,
            isfile:true
          },
          {
            title:this.$t('fanyi._translate[4]'),
            value:'ja2zh',
            active:false,
            isfile:true
          }],
        content:'',
        transHtml:[],
        mode:'',
        delHtml:false,
        bgHtml:[],
        hoverTrans:'',
        hoverTargerHeight:0,
        file:{},
        user:{},
        progress:0,
        fprogress:0,
        isFanyi:false,
        copyFlag:false,
        copyContent:'',
        itemMove:false,
        tags:[],
        clickActive: false
      }
    },
    created(){
        const origin = window.location.origin ;
        if(origin === 'http://localhost:8081'){
          window.location.href = 'http://localhost:8080/fanyi/';
        }else{
           window.location.href = origin +'/fanyi/';
        }
        


        this.user = USER_INFO({})||{};
        document.addEventListener('click', (e) => {
          const dataActive = e.target.getAttribute('data-active') || 0;
          if(dataActive == 1){
            this.clickActive = true;
          }else{
            this.clickActive = false;
          }
        });
        document.addEventListener('drop', (e) => {
          console.log(e.dataTransfer.files);
            if(e.dataTransfer.files.length>0){
              this.file = e.dataTransfer.files[0];
              console.log('获得文件')
              this.getMoveFile();
            }
            e.preventDefault();
        });
        document.addEventListener('dragenter', (e) => {
            this.clickActive = true;
            e.preventDefault();
        });
        getSignature();
    },
    beforeDestroy(){
      clearInterval(statusInterval);
      statusInterval = null;
      document.removeEventListener('click', (e) => {})
    },
    methods: {
      autoText() {
        const text = document.getElementById("textarea");
        autoTextarea(text);
      },
      openLang() {
        this.langModel =true;
      },
      changeLang(item,index) {
          this.list.map(v=>v.active =false);
          this.list[index].active=true;
          this.selectHtml = item.title;
          this.transType = item.value;
          this.langModel = false;
          if(this.file.name){
            this.postFile(this.file,this.transType);
          }
          if(this.content){
              this.translateButton();
          }
     
      },
      onKeyup (e) {
        if(this.oldText == this.content){
              return ;
        }
        this.oldText = this.content;
          if(timer){
            clearTimeout(timer);
            timer = null;
          }
        if(this.content){
          this.delHtml = true;
          timer = setTimeout(()=>{
            this.translate();
            this.autoText();
            clearTimeout(timer);
            timer = null;
          },500)
        }else{
          this.delHtml = false;
          this.clearBox();
        }
      },
      translate () {
        const auto = changeLangeType(this.content,this.transType);
        if(!auto){
            return ;
        }
        if(auto['trans_html']){
            this.selectHtml = auto.trans_html;
        }
        translate(this.content,this.transType).then(res=>{
            if(res.rc===0){
                this.transHtml = res.target;
                this.changeHeight();
            }
        })
      },
      translateButton() {
        if (this.file.name) {
          if(!this.user['_id']){
              return
          }
          if (this.transType == "auto") {
            return;
          }
          this.postFile(this.file,this.transType)
          return
        }
        this.translate();
      },
      clearBox() {
        this.info()
        document.getElementById("textarea").style.height = 140+'px';
        document.getElementById("texttarget").style.height = 140+'px';
      },
      info() {
        this.selectFlag=false;
        this.selectHtml=this.$t('fanyi._translate[0]');
        this.transType='auto';
        this.text='';
        this.translation ='';
        this.fileButton = true;
        this.langModel = false;
        this.mode = '';
        this.list=[
          {
            title:this.$t('fanyi._translate[0]'),
            value:'auto',
            active:true,
            isfile:false
          },{
            title:this.$t('fanyi._translate[1]'),
            value:'zh2en',
            active:false,
            isfile:true
          },
          {
            title:this.$t('fanyi._translate[2]'),
            value:'en2zh',
            active:false,
            isfile:true
          },
          {
            title:this.$t('fanyi._translate[3]'),
            value:'zh2ja',
            active:false,
            isfile:true
          },
          {
            title:this.$t('fanyi._translate[4]'),
            value:'ja2zh',
            active:false,
            isfile:true
          }];
        this.content='';
        this.transHtml=[];
        this.delHtml=false;
        this.bgHtml=[];
        this.hoverTrans = '';
        this.hoverTargerHeight=0;
        this.file={};
        this.upFileBox=false;
        this.isFileSatus=this.$t('fanyi.isFileArr[0]');
        this.copyhtml=this.$t('fanyi.isCopyArr[0]');
        this.copyFlag = true;
        this.progressFlag =false;
        this.progress = 0;
        this.fprogress=0;
        this.isFanyi = false;
        this.copyFlag = false;
        this.copyContent='';
        this.itemMove =false;
        this.clickActive  = false;
        console.log('重置');
      },
      moveItem(i) {
        var sourceArr = this.content.split("\n");
        this.bgHtml= sourceArr.slice(0,i) || [];
        this.hoverTrans = sourceArr[i];
        this.itemMove = true;
      },
      moveLeaveItem() {
        this.bgHtml=[];
        this.hoverTrans = '';
        this.hoverTargerHeight=0;
        this.itemMove =false;
      },
      changeHeight() {
        const t = document.getElementById("textarea");
        const w = document.getElementById("texttarget");
        const t_h = +t.offsetHeight;
        t.style.height = t_h +'px';
        w.style.height = t_h +'px';
      },
      getMoveFile(){
        if(!this.file){
            return ;
        }
        if(this.file.size > (MAXFILE*1024*1024)){
          const file_Message = this.$t('fanyi.message.size_a')+MAXFILE+this.$t('fanyi.message.size_b');
          console.log(file_Message);

          this.showAlertError(file_Message)
          this.info();
          return ;
        }
        if(this.file.type !='application/pdf' && this.file.type!='application/vnd.openxmlformats-officedocument.wordprocessingml.document'){
          this.showAlertError(`${this.$t('fanyi.message.format')}`);
          this.info();
          return
        }
        this.upFileBox = true;
        this.langModel = true;
        this.list.map(v=>v.active =false);
        this.clickActive  = true;
        this.selectHtml= this.$t('fanyi.message.change_lang');
      },
      changeFile(e) {
        this.file = e.target.files[0];
        this.getMoveFile();
      },
      showAlertError (des) {
        Message({
          message: des,
          type: 'error',
          duration: 5 * 1000,
        })
//        this.$notify.error({
//          title: '错误',
//          message: des,
//          offset: 100,
//          duration:4000
//        });
      },
      postFile (file,trans_type) {
        this.progressFlag = true;
        postFile(file, trans_type ,this.user._id,(e)=>{
          let num = Math.round((e.loaded / e.total) * 100)
          this.progress = num;
          this.isProgress = `${this.$t('fanyi.progress')}${num}%`
        }).then(res=>{
            const data = res.data;
            if(data.rc==0){
              this.progress = 100;
              this.isProgress = `${this.$t('fanyi.progress')}100%`;
              this.startStatusInterval(data.doc_id);
            }else {
              if (res.rc == -1){
                this.showAlertError(`${this.$t('fanyi.message.format')}`);
              } else if (res.rc == -2 ){
                this.showAlertError(`${this.$t('fanyi.message.ts_error')}`);
              } else {
                this.showAlertError(`${this.$t('fanyi.message.up_error')}`);
              }
            }
        }).catch(err=>{
            console.log(err);
            this.showAlertError(`${this.$t('fanyi.message.up_fail')}`);
        })
      },
      clearFile() {
        this.info();
      },
      startStatusInterval (docId) {
        this.isFanyi = true;
        this.isFileSatus=this.$t('fanyi.isFileArr[1]');
        this.isProgress = `${this.$t('fanyi.pre_progress')+'0%'}`
        statusInterval = setInterval( ()=> {
          getStatus(docId)
            .then((data) => {
                if (data.rc == 0) {
                  if (data.preview_status == 2 ||data.status==2) {
                    this.isProgress =`${this.$t('fanyi.pre_progress')+'100%'}`
                    this.fprogress = 100;
                    clearInterval(statusInterval);
                    statusInterval=null;
                    this.$router.push({ path: '/pdf_view/'+ docId})
                  }else if(data.preview_status == 3 ||data.status == 3 || 
                           data.preview_status == 4 || data.status== 4 || 
                           data.preview_status == -1 || data.status== -1){
                    clearInterval(statusInterval);
                    statusInterval=null;
                    if(data.preview_status == 4 ||data.status==4){
                      this.showAlertError(`${this.$t('fanyi.message.changePdf')}`);
                    }else{
                      this.showAlertError(`${this.$t('fanyi.message.ts_fail')}`);
                    }

                  }else{
                    this.isProgress =`${this.$t('fanyi.pre_progress')}${data.preview_progress || 0}%`;
                    this.fprogress = data.preview_progress || 0;
                  }
                } else{
                  clearInterval(statusInterval);
                  statusInterval=null;
                  this.showAlertError(`${this.$t('fanyi.message.ts_no')}`);
                }
            })
        }, 3000)
      },
      copyMove () {
        this.copyhtml = this.$t('fanyi.isCopyArr[0]');
        this.copyFlag = true;
        this.copyContent = this.content;
      },
      copyLeave() {
        this.copyhtml = this.$t('fanyi.isCopyArr[0]');
        this.copyFlag = false;
        this.copyContent = '';
      },
      isLogin(event){
        if(!this.user['_id']){
          console.log('未登录');
          this.$refs.loginModel.show();
          event.preventDefault();
        }
      },
      copy(){
        this.copyFlag = true;
        this.copyContent = this.content;
        var clipboard = new Clipboard('.tool-copy');
        clipboard.on('success', e => {
          this.copyhtml = this.$t('fanyi.isCopyArr[1]');
          // 释放内存
          clipboard.destroy();
        })
        clipboard.on('error', e => {
          // 不支持复制
          this.copyhtml =this.$t('fanyi.isCopyArr[2]');
          // 释放内存
          clipboard.destroy();
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/fanyiup.vue